import React from "react";

const TechnicalAnalysisIcon = (props: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="#667085"
      className="size-6"
      {...props}
    >
      <path d="M3 3v18h18" strokeLinecap="round" strokeLinejoin="round" />

      <path
        d="M6 15l3-3 3 2 4-5 2 2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <rect x="5" y="10" width="1.5" height="5" rx="0.5" />
      <rect x="9" y="8" width="1.5" height="7" rx="0.5" />
      <rect x="13" y="6" width="1.5" height="9" rx="0.5" />
      <rect x="17" y="9" width="1.5" height="6" rx="0.5" />
    </svg>
  );
};

export default TechnicalAnalysisIcon;
